/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditDescribeRequest extends models.RequestAuditBaseRequest {
    getFixupPrototypeFunction() { return RequestAuditDescribeRequest.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditDescribeRequest>): RequestAuditDescribeRequest {
        let obj = Object.assign(new RequestAuditDescribeRequest(), model);
        RequestAuditDescribeRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditDescribeRequest>): RequestAuditDescribeRequest {
        if (!model) return null;
        return RequestAuditDescribeRequest.newInstance(<RequestAuditDescribeRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditDescribeRequest) {
        if (!obj) return;

        models.RequestAuditDescribeRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditDescribeRequest): boolean {
        if (models.RequestAuditBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RequestAuditDescribeRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
